__turbopack_context__.v({
  "badge": "YuOF7a_badge",
  "icon": "YuOF7a_icon",
});
